import {
  PalletInterlayer,
  PalletLayer,
  PalletLayerGroup,
} from 'src/app/core/types';
import {
  filterLoadedLayerTypes,
  getLoadedLayerCount,
} from './pallet-loading-space.helper';

export type PalletListDisplayRow =
  | { kind: 'layer'; layer: PalletLayer; layerIndex: number }
  | { kind: 'interlayer'; interlayer: PalletInterlayer; slotIndex: number };

export function getPalletListDisplayRows(palletGroup: PalletLayerGroup): PalletListDisplayRow[] {
  const allLayers = palletGroup.layers ?? [];
  const layers = allLayers
    .map((layer, layerIndex) => ({ layer, layerIndex }))
    .filter(({ layer }) => filterLoadedLayerTypes([layer]).length > 0);
  const interlayer = palletGroup.interlayer;

  const layerRows: PalletListDisplayRow[] = layers.map(({ layer, layerIndex }) => ({
    kind: 'layer',
    layer,
    layerIndex,
  }));

  if (!interlayer) {
    return layerRows;
  }

  return [
    ...layerRows,
    {
      kind: 'interlayer',
      interlayer,
      slotIndex: 0,
    },
  ];
}

export function countTotalStackedLayers(palletGroup: PalletLayerGroup): number {
  return filterLoadedLayerTypes(palletGroup.layers ?? []).reduce(
    (sum, layer) => sum + getLoadedLayerCount(layer),
    0,
  );
}

export function maxInterlayerFrequencyLayers(palletGroup: PalletLayerGroup): number {
  const total = countTotalStackedLayers(palletGroup);
  return Math.max(1, total - 1);
}
